import React from "react";
import MasterLayout from "../otherImages/MasterLayout";
import PackageDataTable from "../components/PackageDataTable";
import DefaultTopBar from "../components/DefaultTopBar";

const ManagePackages = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout> 

        <DefaultTopBar
            title="Booking List"
            desc="View, create, edit, and manage bookings efficiently."
        />

        {/* TableDataLayer */}
        <PackageDataTable />

      </MasterLayout>

    </>
  );
};

export default ManagePackages; 
